import { render, staticRenderFns } from "./BetslipHeader.vue?vue&type=template&id=7b80c37d&scoped=true"
import script from "./BetslipHeader.vue?vue&type=script&lang=js"
export * from "./BetslipHeader.vue?vue&type=script&lang=js"
import style0 from "./BetslipHeader.vue?vue&type=style&index=0&id=7b80c37d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b80c37d",
  null
  
)

export default component.exports